<template>
  <div class="studyplan-list">
    <div class="goods-list">
      <!-- 商品列表 -->
      <div v-for="(item, index) in goodsDetail" :key="index" class="goods-card">
        <div class="goods-item" @click="selectItem(item)">
          <div class="goods-choose" :class="{ 'choose': item.goodsId === selectedPlan.goodsId }"></div>
          <div class="title">{{ item.goodsName }}</div>
          <div class="desc">{{ item.goodsDescrition }}</div>
          <div class="goods-img"><img :src="item.listCover" /></div>
          <!-- 专辑列表 -->
          <div class="album-list">
            <div class="album-item" v-for="(album, albumIndex) in item.albumsInfo" :key="albumIndex">
              <span class="album-border"></span>
              <span class="album-name">{{ album.albumName }}</span>
              <span class="album-teacher_name">主讲人：{{ getTeacherNames(album) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'studyplan-list',
  data() {
    return {
      list: [
        { id: 1, goodsName: '灯塔计划', desc: '去往宽阔的世界，并把它呈现在我们眼前', goodsImg: 'https://img-cdn1.ylyk.com/image/1606824358997_m1606824264414_s69957.jpg',
          albums: [
            { albumName: '哲学的故事', teacherNames: '夏鹏、覃晔' },
            { albumName: 'J·K·罗琳：生活没有魔法', teacherNames: '夏鹏、覃晔' },
            { albumName: '常用英文近义词解析', teacherNames: '夏鹏、覃晔' },
            { albumName: '善用言辞巧沟通', teacherNames: '夏鹏、覃晔' }
          ]
        },
        { id: 2, goodsName: '绿洲计划', desc: '去往宽阔的世界，并把它呈现在我们眼前', goodsImg: 'https://img-cdn1.ylyk.com/image/1606824358997_m1606824264414_s69957.jpg', albums: [{ albumName: '哲学的故事', teacherNames: '夏鹏、覃晔' }] },
        { id: 3, goodsName: '水手计划', desc: '去往宽阔的世界，并把它呈现在我们眼前', goodsImg: 'https://img-cdn1.ylyk.com/image/1606824358997_m1606824264414_s69957.jpg', albums: [{ albumName: '哲学的故事', teacherNames: '夏鹏、覃晔' }] },
        { id: 4, goodsName: '水手计划', desc: '去往宽阔的世界，并把它呈现在我们眼前', goodsImg: 'https://img-cdn1.ylyk.com/image/1606824358997_m1606824264414_s69957.jpg', albums: [{ albumName: '哲学的故事', teacherNames: '夏鹏、覃晔' }] }
      ]
      // 选择的项
      // select: {
      //   id: 0,
      //   item: {}
      // }
    }
  },
  computed: {
    ...mapGetters('goods/vip', [
      'goodsDetail',
      // 限购规则
      'limitData'
    ]),
    ...mapGetters('goods-studyplan/plan', [
      'selectedPlan'
    ])
  },
  methods: {
    selectItem(item) {
      if (item.goodsId === this.selectedPlan.goodsId) {
        item = {} // 取消选择
      }
      this.$store.commit('goods-studyplan/plan/setSelectedPlan', item)
    },
    getTeacherNames(album) {
      const { teacherNames } = album
      const names = teacherNames.split('、')
      // 1个作者
      if (names.length < 2) {
        return teacherNames
      }
      // 2个作者
      names.forEach((name, index) => {
        if (name.indexOf(' ') > 0) {
          const n = name.split(' ')
          n.shift() // 移除名
          names[index] = n.join(' ')
        }
      })
      return names.join('、')
    }
  }
}
</script>

<style lang="less" scoped>
.studyplan-list {
  background: #212B2E;
  min-height: 10rem;
  // 让出底部报名计划的高度
  padding-bottom: 2rem;
  .goods-list {
    padding-top: 0.5rem;
    .goods-card {
      margin: 0 0.37rem 0.5rem 0.37rem;
      display: flex;
      .goods-item {
        background: linear-gradient(90deg, #E4D6C9 0%, #DDB999 100%);
        border-radius: 0.09rem;
        width: 100%;
        position: relative;
        .goods-choose {
          background: url("../../../../../images/goods-studyplan/goods-choose.png") no-repeat;
          background-size: 100% 100%;
          width: .75rem;
          height: .75rem;
          position: absolute;
          right: 0px;
          top: 0px;
          &.choose {
            background: url("../../../../../images/goods-studyplan/goods-choose-is.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        .title {
          color: #683100;
          font-weight: bold;
          width: 2.15rem;
          line-height: 0.56rem;
          margin: 0.25rem 0 0 0.28rem;
          font-size: 0.3rem;
          background: url("../../../../../images/goods-studyplan/emailcard_title_bg.png") no-repeat;
          background-size: 100% 100%;
        }
        .desc {
          color: #683100;
          margin: 0.19rem 0.28rem 0 0.28rem;
          font-size: 0.22rem;
        }
        .goods-img img {
          margin: 0.19rem 0.28rem 0.28rem 0.28rem;
          width: 91.01%;
          height: 1.87rem;
        }
      }
      .album-list {
        padding-bottom: 0.28rem;
        .album-item {
          display: flex;
          &:nth-child(odd) {
            background: rgba(199, 154, 115, 0.2);
          }
          .album-border {
            width: 0.11rem;
            height: 0.37rem;
            margin: 0.2rem 0.19rem 0.19rem 0.28rem;
            background: url("../../../../../images/goods-studyplan/album-border.png") no-repeat;
            background-size: 100% 100%;
          }
          .album-name {
            font-size: 0.26rem;
            font-weight: bold;
            color: #683100;
            line-height: 0.37rem;
            margin: 0.19rem 0 0.19rem 0;
            flex: 1;
          }
          .album-teacher_name {
            font-size: 0.22rem;
            font-weight: 400;
            color: rgba(104, 49, 0, 0.8);
            line-height: 0.37rem;
            margin: 0.19rem 0.28rem 0.19rem 0.19rem;
            // max-width: 3rem;
          }
        }
      }
    }
  }
}
</style>